import { render, staticRenderFns } from "./IncidenciasSoftwareFinalizadas.vue?vue&type=template&id=cb6085ec&"
import script from "./IncidenciasSoftwareFinalizadas.vue?vue&type=script&lang=js&"
export * from "./IncidenciasSoftwareFinalizadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports